import React, { Component } from 'react'
import getLabel from '../../utilities/label.js'
import TitleBar from '../TitleBar'
import ReactModal from 'react-modal'
import _ from 'lodash'

export default class UserNote extends Component {
  constructor(props) {
    super(props)
    this.state = {
      flashMessage: '',
      note: this.props.note || '',
      user: this.props.user || '',
      sessionName: this.props.sessionName || '',
      sponsorName: this.props.sponsorName || '',
      showShareModal: false,
      isEditing: false
    }
    this.toggleShareModal = this.toggleShareModal.bind(this)
    this.changeNote = this.changeNote.bind(this)
    this.toggleEditing = this.toggleEditing.bind(this)
    this.saveOrEdit = this.saveOrEdit.bind(this)
    this.saveNote = this.saveNote.bind(this)
    this.displayText = this.displayText.bind(this)
    this.emailThisNote = this.emailThisNote.bind(this)
    this.emailAllNotes = this.emailAllNotes.bind(this)
  }

  toggleShareModal(){
    this.setState({
      showShareModal: !this.state.showShareModal
    })
  }

  changeNote(e) {
    this.setState({
      flashMessage: '',
      note: e.target.value
    })
  }

  saveOrEdit() {
    this.state.isEditing ?
      this.saveNote() :
      this.toggleEditing()
  }

  toggleEditing() {
    this.setState({
      isEditing: !this.state.isEditing
    })
  }

  trackEditScreen(){
    var noteType = this.props.noteType
    switch (noteType) {
    case 'userNote':
      window.trackPage('NoteFormUserScreen')
      break
    case 'sessionNote':
      window.trackPage('NoteFormSessionScreen')
      break
    case 'sponsorNote':
      window.trackPage('NoteFormSponsorScreen')
      break
    default: return
    }
  }

  trackShowScreen(){
    var noteType = this.props.noteType
    switch (noteType) {
    case 'userNote':
      window.trackPage('NoteDetailUserScreen')
      break
    case 'sessionNote':
      window.trackPage('NoteDetailSessionScreen')
      break
    case 'sponsorNote':
      window.trackPage('NoteDetailSponsorScreen')
      break
    default: return
    }
  }

  saveNote() {
    let data = this.props.postData
    data.body = this.state.note
    if(data.body) {
      this.props.postResource({ key: 'note', data: data, callback: () => {
        this.props.flashMessage({
          message: getLabel('note_saved')
        })
        this.props.toggleNote()
      }})
    } else {
      this.setState({
        flashMessage: getLabel('note_error')
      })
    }
  }

  getEmailHeading() {
    let heading
    if(this.state.user) {
      heading = this.state.user.first_name + ' ' + this.state.user.last_name
    } else if(this.state.sessionName) {
      heading = this.state.sessionName
    } else if(this.state.sponsorName) {
      heading = this.state.sponsorName
    }
    return heading.toUpperCase()
  }

  emailThisNote() {
    var subject = getLabel({ key: 'note' }) + ': ' + window.currentUser.current_event_name
    var heading = this.getEmailHeading()
    var noteBody = encodeURI(this.state.note)
    this.setState({ showShareModal: false })
    window.location.href = 'mailto: ?subject=' + subject+ '&body=' + heading + '%0A' + noteBody
  }

  emailAllNotes() {
    var usersWithNotes = []
    var userNotes = ''
    var sessionsWithNotes = []
    var sessionNotes = ''
    var sponsorsWithNotes = []
    var sponsorNotes = ''
    var subject = getLabel({ key: 'note', plular: true }) + ': ' + window.currentUser.current_event_name

    var users = JSON.parse(localStorage.getItem('users'))
    _.each(users.event_users, (user) => {
      if(user.note_on_user) {
        usersWithNotes.push(user)
      }
    })
    if(usersWithNotes.length > 0){
      _.each(usersWithNotes, (user) => {
        userNotes += user.first_name.toUpperCase() + ' ' + user.last_name.toUpperCase() + '%0A'
        userNotes += encodeURI(user.note_on_user) + '%0A%0A'
      })
      userNotes = (getLabel('user') + ' ' + getLabel({ key: 'note', plural: true })).toUpperCase() + '%0A%0A' + userNotes
    }

    var sessions = JSON.parse(localStorage.getItem('sessions'))
    _.each(sessions.sessions, (session) => {
      if(session.note_on_session) {
        sessionsWithNotes.push(session)
      }
    })
    if(sessionsWithNotes.length > 0){
      _.each(sessionsWithNotes, (session) => {
        sessionNotes += session.name.toUpperCase() + '%0A'
        sessionNotes += encodeURI(session.note_on_session) + '%0A%0A'
      })
      sessionNotes = (getLabel('session') + ' ' + getLabel({ key: 'note', plural: true })).toUpperCase() + '%0A%0A' + sessionNotes
    }

    var sponsors = JSON.parse(localStorage.getItem('sponsors'))
    _.each(sponsors.sponsors, (sponsor) => {
      if(sponsor.note_on_sponsor) {
        sponsorsWithNotes.push(sponsor)
      }
    })
    if(sponsorsWithNotes.length > 0){
      _.each(sponsorsWithNotes, (sponsor) => {
        sponsorNotes += sponsor.name.toUpperCase() + '%0A'
        sponsorNotes += encodeURI(sponsor.note_on_sponsor) + '%0A%0A'
      })
      sponsorNotes = (getLabel('sponsor') + ' ' + getLabel({ key: 'note', plural: true })).toUpperCase() + '%0A%0A' + sponsorNotes
    }

    this.setState({ showShareModal: false })
    window.location.href = 'mailto: ?subject=' + subject + '&body=' + userNotes + '%0A' + sessionNotes + '%0A' + sponsorNotes
  }

  displayText() {
    const {
      isEditing,
      note } = this.state
    // replace newline with space because the placeholder attribute doesnt do newlines
    const placeholderText = getLabel('note_placeholder').replace('\\n', ' ')
    if (isEditing) {
      this.trackEditScreen()
      return (
        <textarea
          className="form-control margin-top-10"
          onChange={ this.changeNote }
          placeholder={ placeholderText }
          autoFocus={ true }
          value={ note }
        />
      )
    } else {
      this.trackShowScreen()
      return (
        <div
          style={{ whiteSpace: 'pre-wrap' }}>
          { note ? note : placeholderText }
        </div>
      )
    }
  }

  render() {
    const {
      flashMessage,
      showShareModal,
      note,
      isEditing } = this.state
    const shareButton = '<i class=\'fa fa-paper-plane-o\' aria-hidden=\'true\'></i>'
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    return (
      <div className="note-page">
        <TitleBar
          title={ getLabel('note') }
          leftButtonLabel={ backButton }
          leftButtonAction={ this.props.toggleNote }
          rightButtonLabel={ shareButton }
          rightButtonAction={ this.toggleShareModal }
        />
        { this.props.children }
        { this.displayText() }
        <div
          className="note-buttons"
          style={{ width: '100%', textAlign: 'center' }}>
          <button
            className="save-note-button"
            onClick={ this.saveOrEdit }>
            { isEditing ? getLabel('save') : getLabel('edit') }
          </button>
        </div>
        { flashMessage &&
          <div className={ note ? 'success-color' : 'error-color' } >
          	{ flashMessage }
          </div>
        }
        <div className="clear"></div>
        <ReactModal
          className="react-modal note-modal"
          isOpen={ showShareModal }
          appElement={ document.querySelector('#root') }>
          <button
            className='modal-menu-item'
            onClick={ this.emailThisNote } >
            { getLabel('email_this_note')}
          </button>
          <div className="modal-menu-divider" />
          <button
            className='modal-menu-item'
            onClick={ this.emailAllNotes } >
            { getLabel('email_all_notes')}
          </button>
          <div className="modal-menu-divider" />
          <button
            className='modal-menu-item'
            onClick={ this.toggleShareModal }>
            { getLabel('cancel') }
          </button>
        </ReactModal>
      </div>
    )
  }
}
